module.exports = new __parcel__URL__("purpleBar.40dceaa5.svg").toString();